/**
 * Shortens description of the sensor binary
 * @param {*} param0
 * @returns shortened description.
 */
export const shortenDescription = ({ description, descriptionLength }) => {
  const desc = String(description);
  const shorterDescription =
    desc.length > descriptionLength
      ? `${desc.substring(0, descriptionLength)}...`
      : description;
  return shorterDescription;
};
